var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M91.66,70.31C86.81,54.52,79.77,32.39,61.47,25.74a14.62,14.62,0,0,0-1.16-4.91c1.16-.92,1.76-1.06,3.72-1.59s.43-7.81-3-10C58.64,7.79,56.53,9,54.15,10.6a8.4,8.4,0,0,0-4.28-2.82l.87-3.1c.71-3.33-3-5.37-5.81-3.42-1.32.92-1.81,3.53-2.16,5.6-.58.06-1.13.15-1.56.23l-.89-4.54c-.79-3-4.77-3.19-7-1.35C30.68,2.8,33,8,34,10.29A12.69,12.69,0,0,0,31.8,12c-1.12-1.42-3-6.84-5.17-6.94a6,6,0,0,0-6.1,3.41c-1.67,2.34,3.58,8.42,4.34,10.46a18.62,18.62,0,0,0-4.44,9c-3-3-5-3.31-7.33-4-5.82-1.8-8.56,8.11-5.58,9.44,4.26,1.89,5.1,2.25,6.46,4.2C6.4,45.11,7,59.41,13,66.29c4.8,25.87,30.85,34.16,58,33.69C88.55,99.68,98.15,89.05,91.66,70.31Z","transform":"translate(-6.31)"}));
}

Heart.defaultProps = {"viewBox":"0 0 87.39 100"};

module.exports = Heart;

Heart.default = Heart;
